import Vue from 'vue'
import VueRouter from 'vue-router'
import homePage from '../views/homePage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: homePage
  },
  {
    path: '/:channel',
    name: 'home',
    component: homePage
  },
  {
    path: '/:channel/:invitecode',
    name: 'home',
    component: homePage
  },
]

const router = new VueRouter({
  mode: "history",
  base: "dxz",
  routes
})

router.beforeEach((to,from,next) => {
  // console.log(to);
  if (to.params.channel === 'fb101') { // 判断是否有标题
    document.title = '【預約領取】';
  }
  next()
});
export default router
